const ACTIONS = {
  JOIN: "join",
  JOINED: "joined",
  DISCONNECTED: "disconnected",
  CODE_CHANGE: "code-change",
  SYNC_CODE: "sync-code",
  LEAVE: "leave",
  SPACEDATA_CHANGE: "spaceData-change",
  LEFT: "left",
  FILE_METADATA_CHANGE: "file-metadata-change",
  SYNC_FILE_METADATA: "sync-file-metadata",
};

module.exports = ACTIONS;
